import { Currency } from '@/core/currency/interfaces';

const UYU: Currency = {
    name: 'Uruguayan Peso',
    demonym: 'Uruguayan',
    majorSingle: 'Peso',
    majorPlural: 'Pesos',
    codeNumeric: '858',
    symbol: '$U',
    symbolNative: '$',
    minorSingle: 'Centésimo',
    minorPlural: 'Centésimos',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'UYU',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default UYU;
